<template>
  <div class="box-poput">
    <div id="poput" v-drag class="sctool">
      <!-- 色盘 -->
      <com-color id="poputColor" class="com-color" :value="colorVal" @upColor="upColorFn"></com-color>

      <!-- 颜色值圆 -->
      <div class="sctool-round">
        <div
          v-for="(val, key) in colorPool"
          :key="key"
          :data-color="val.color"
          :style="{backgroundColor: val.color }"
          @click="sctool_color_open(val.color,val.it,key)"
          @mouseover="colorOver(val.color,val.it)"
          @mouseout="colorOut(val.color,val.it)"
        >
          <span></span>
        </div>
      </div>

      <!-- 工具按钮 -->
      <ul class="sctool-tool">
        <li @click="copy_fn" class="sctool-li1">
          <p>复制</p>
        </li>
        <li class="sctool-li0"></li>
        <li @click="shear_fn" class="sctool-li2">
          <p>剪切</p>
        </li>
        <li class="sctool-li0"></li>
        <li @click="delete_fn" class="sctool-li3 sc-btn" data-type="remove">
          <p>删除</p>
        </li>
        <li class="sctool-li0"></li>
        <li class="sctool-li4 sc-btn" @click="moveDom(0)" data-type="moveup">
          <p>上移</p>
        </li>
        <li class="sctool-li0"></li>
        <li class="sctool-li5 sc-btn" @click="moveDom(1)" data-type="movedown">
          <p>下移</p>
        </li>
        <li class="sctool-li0"></li>
        <li class="sctool-li6 sc-btn" @click="insertparagraphtrue_fn" data-type="addbefore">
          <p>前空行</p>
        </li>
        <li class="sctool-li0"></li>
        <li class="sctool-li7 sc-btn" @click="insertparagraph_fn" data-type="addafter">
          <p>后空行</p>
        </li>
        <li class="sctool-li0"></li>
        <li class="sctool-li8" @click="clear_fn">
          <p>清除格式</p>
        </li>
        <li class="sctool-li0"></li>
        <li class="sctool-li9" @click="toImg">
          <p>转为图片</p>
        </li>
        <li class="sctool-li0"></li>
        <li class="sctool-li10" @click="setBorder">
          <p>边框</p>
        </li>
        <li class="sctool-li0"></li>
        <li class="sctool-li11 sc-btn" @click="transmit">
          <p>传递</p>
        </li>
      </ul>
      <!-- 
        <ul class="sctool-tool">
        <li class="sctool-li0"></li>
        <li class="sctool-li7" onclick="duanluo_dan(o);__sendCount('sc_duanluo');">
          <p>段落</p>
          <i class="fa fa-caret-down" aria-hidden="true"></i>
        </li>
        <li class="sctool-li0"></li>
        <li class="sctool-li8" onclick="__sendCount('sc_beijing');is_count=1;beijingtu_huan(o);">
          <p>背景图</p>
        </li>
        <li class="sctool-li0"></li>
        <li class="sctool-li11" onclick="shoucang_dan(o);__sendCount('sc_diy');">
          <p>DIY收藏</p>
        </li>
        <li class="sctool-li0"></li>
        <li class="sctool-li12" onclick="more(this,o)">···</li>
      </ul>-->

      <!-- 透明度-旋转-宽度比-倒影 -->
      <ul class="sctool-type" style="cursor: default; display: block;">
        <li class="sctool-type-l1">
          <span class="demonstration">透明度</span>
          <!-- <p class="sctool-type-l1-p1">透明度</p> -->
          <el-slider
            class="sctool-slider"
            show-input
            v-model="value[0]"
            :step="1"
            :min="0"
            :max="100"
            @change="change_value_fn(0)"
          ></el-slider>
        </li>
        <li class="sctool-type-l1" style="margin-top:8px;">
          <span class="demonstration">旋&nbsp; &nbsp;转</span>
          <el-slider
            class="sctool-slider"
            show-input
            v-model="value[1]"
            :step="1"
            :min="-180"
            :max="180"
            @change="change_value_fn(1)"
          ></el-slider>
        </li>
        <li class="sctool-type-l1" style="margin-top:8px;">
          <span class="demonstration">宽度比</span>
          <el-slider
            class="sctool-slider"
            show-input
            v-model="value[2]"
            :step="1"
            :min="0"
            :max="100"
            @change="change_value_fn(2)"
          ></el-slider>
        </li>
      </ul>

      <!-- 边框弹窗 -->
      <!-- 特殊样式 -->
      <!-- 
        <ul class="sctool2-ul">
        <li
          class="sctool2-l1 disinput"
          title="锁定工具条位置"
          style="display: block;"
          onclick="dingzi($TOOL,this);"
        >
          <div class="sctool2-d1">
            <span>锁 &nbsp;定</span>
          </div>
        </li>
        <li class="sctool2-l1" onclick="incr(o);__sendCount('sc_incr')" style="display: none;">
          <div class="sctool2-d1">
            <span class="sctool2-d1-span1">
              <i class="fa fa-plus" style="margin-left:2px;"></i> &nbsp;1
            </span>
          </div>
        </li>
        <li
          class="sctool2-l1"
          onclick="scBorder(o);__sendCount('sc_border')"
          style="display: list-item;"
        >
          <div class="sctool2-d1">
            <span class="sctool2-d1-span1">边 &nbsp;框</span>
          </div>
        </li>
        <li
          class="sctool2-l1"
          onclick="bulletScreen(o);__sendCount('sc_bulletScreen')"
          style="display: none;"
        >
          <div class="sctool2-d1">
            <span class="sctool2-d1-span1">弹 &nbsp;幕</span>
          </div>
        </li>
        <li
          class="sctool2-l1"
          onclick="smallImg(o);__sendCount('sc_smallImg')"
          style="display: list-item;"
        >
          <div class="sctool2-d1">
            <span class="sctool2-d1-span1">换小图</span>
          </div>
        </li>
        <li
          class="sctool2-l1"
          onclick="cutOffRule(o);__sendCount('sc_cutOffRule')"
          style="display: none;"
        >
          <div class="sctool2-d1">
            <span class="sctool2-d1-span1">分割线</span>
          </div>
        </li>
        <li class="sctool2-l1" onclick="bianhao(o);__sendCount('sc_sort')" style="display: none;">
          <div class="sctool2-d1">
            <span class="sctool2-d1-span1">排 &nbsp;序</span>
          </div>
        </li>
        <li class="sctool2-l1" onclick="huaTu1(Te);__sendCount('sc_hdincr')" style="display: none;">
          <div class="sctool2-d1">
            <span>
              <i class="fa fa-plus" style="margin-left:2px;"></i>
            </span>&nbsp;
            <span onclick="event.stopPropagation();__sendCount('sc_hdincr2');huaTu2(Te)">
              <i class="fa fa-minus" style="margin-left:10px;"></i>
            </span>
          </div>
        </li>
        <li
          class="sctool2-l1"
          onclick="seamless(o);__sendCount('sc_seamless')"
          style="display: none;"
        >
          <div class="sctool2-d1">
            <span class="sctool2-d1-span1">缝清除</span>
          </div>
        </li>
        <li
          class="sctool2-l1"
          onclick="layoutAdd(o,1);__sendCount('sc_leftadd')"
          style="display: none;"
        >
          <div class="sctool2-d1">
            <span class="sctool2-d1-span1">左 +1</span>
          </div>
        </li>
        <li
          class="sctool2-l1"
          onclick="layoutAdd(o,0);__sendCount('sc_rightadd')"
          style="display: none;"
        >
          <div class="sctool2-d1">
            <span class="sctool2-d1-span1">右 +1</span>
          </div>
        </li>
        <li class="sctool2-l1 sctool2-l11" style="display: none;">
          <div class="sctool2-d1 sctool2-d11">
            <span
              onclick="scPosition(o,'top');__sendCount('sc_position1')"
              class="sctool2-d1-span1 sctool2-d1-span2 sctool2-d1-span3"
            >
              <i class="fa fa-align-left" aria-hidden="true"></i>
            </span>
            <span
              onclick="scPosition(o,'middle');__sendCount('sc_position2')"
              class="sctool2-d1-span1 sctool2-d1-span2 sctool2-d1-span4"
            >
              <i class="fa fa-align-center" aria-hidden="true"></i>
            </span>
            <span
              onclick="scPosition(o,'bottom');__sendCount('sc_position3')"
              class="sctool2-d1-span1 sctool2-d1-span2 sctool2-d1-span5"
            >
              <i class="fa fa-align-right" aria-hidden="true"></i>
            </span>
          </div>
        </li>
      </ul>-->
      <!-- 段落 -->
      <!-- <div class="sctool-phase" style="display: none;">
        <i class="fa fa-caret-up" aria-hidden="true"></i>
        <ul>
          <li>
            <p>字&nbsp; &nbsp;号</p>
            <input type="text" name="font-size">
            <span>px</span>
          </li>
          <li>
            <p>行&nbsp; &nbsp;高</p>
            <input type="text" name="line-height">
            <span>em</span>
          </li>
          <li>
            <p>字间距</p>
            <input type="text" name="letter-spacing">
            <span>px</span>
          </li>
          <li>
            <p>缩&nbsp; &nbsp;进</p>
            <input type="text" name="text-indent">
            <span>em</span>
          </li>
          <li>
            <p>段前距</p>
            <input type="text" name="margin-top">
            <span>px</span>
          </li>

          <li>
            <p>段后距</p>
            <input type="text" name="margin-bottom">
            <span>px</span>
         </li>
      </ul>
      </div>-->
    </div>
    <com-set-border
      v-on:msg_close_set_border="msg_close_set_border_fn"
      v-show="show_set_border"
      class="com-set-border"
      :items="items_border"
      :node="node_border"
    ></com-set-border>
  </div>
</template>

<script>
import comColor from "./com-color";
import comSetBorder from "./com-set-border";
import * as clipboard from "clipboard-polyfill";
import domtoimage from "dom-to-image";
import comcolor from "./com-color";
import { setInterval, clearInterval } from "timers";
import Vue from "vue";
export default {
  name: "comPoput",
  data() {
    return {
      items: [
        [
          "#ffdfe1",
          "#f9c3cd",
          "#efa9a9",
          "#f597ab",
          "#ed8ba5",
          "#f17c83",
          "#f5a7b9",
          "#e97a91",
          "#d1104c",
          "#faf5dd",
          "#fff7db",
          "#f9e9c1",
          "#fadf70",
          "#ffd71a",
          "#e5bf10",
          "#fdd316",
          "#dfc342",
          "#f4bf4c",
          "#b78b26",
          "#f7dfb5",
          "#f5e37a",
          "#fcb500",
          "#f7c172",
          "#f3bd81",
          "#e0c99d",
          "#f7dfb5",
          "#ebc926",
          "#e3c79b",
          "#e5bd3a",
          "#adffcb",
          "#91f7d7",
          "#6affdf",
          "#00ffe5",
          "#22f306",
          "#9bbb87",
          "#bfd72e",
          "#b7e13a",
          "#76bb38",
          "#4e8b20",
          "#bde7f3",
          "#8bd7e5",
          "#70cfe3",
          "#a3dbe9",
          "#0eb1c9",
          "#22a3c3",
          "#66a9c9"
        ],
        [
          "#ff9100",
          "#875646",
          "#87463e",
          "#543826",
          "#262e38",
          "#ff5432",
          "#f97852",
          "#566487",
          "#a5662c",
          "#818b8f",
          "#c9c1a7",
          "#3c6897",
          "#084074",
          "#124630",
          "#2e2e34",
          "#edf2fb",
          "#f5b170",
          "#c31c46",
          "#c5141c",
          "#626c7a",
          "#c9c7a1",
          "#32a3b1",
          "#26709d",
          "#206c22",
          "#4e5646",
          "#a78d70",
          "#585a4e",
          "#ff7c14",
          "#8781a3",
          "#d54a28",
          "#523a4a",
          "#56242a",
          "#403836",
          "#382426",
          "#32282e",
          "#d974a3",
          "#ed895e",
          "#9783b7",
          "#971212",
          "#c9466c",
          "#64363c",
          "#34705a",
          "#cb4a64",
          "#203048",
          "#060000",
          "#d54444"
        ]
      ],
      show_set_border: false,
      items_border: {},
      node_border: "",
      show_color: false,
      history: [],
      clear_time: null,
      colorIdx: NaN,
      colorVal: "#000000",
      valueOpacity: 100
    };
  },
  props: {
    value: {
      type: Array,
      required: true
    },
    colorPool: {
      type: Array,
      required: true
    }
  },
  methods: {
    //转为图片
    toImg() {
      domtoimage
        .toJpeg(choose_node[0], { bgcolor: "#fff", quality: 0.95 })
        .then(function(dataUrl) {
          var link = document.createElement("a");
          link.download = "my-image-name.jpeg";
          link.href = dataUrl;
          link.click();
        });
    },
    //传递
    transmit() {
      let id = $(choose_node).data("id");
      $("#ueditor_0")
        .contents()
        .find(`[dtat-id=${id}]`);
    },
    //滑块事件
    change_value_fn(idx) {
      if (idx == 0) {
        $(choose_node).css("opacity", this.value[idx] / 100);
      } else if (idx == 1) {
        $(choose_node).css("transform", `rotatez(${this.value[idx]}deg)`);
      } else if (idx == 2) {
        $(choose_node).css("width", `${this.value[idx]}%`);
      }
    },
    //拷贝
    copy_fn() {
      this.$notify({
        title: "复制成功",
        type: "success",
        duration: 1000
      });
      var dt = new clipboard.DT();
      let content = $("<div></div>")
        .append($(choose_node).clone(true))
        .html()
        .split("active");
      dt.setData("text/plain", content);
      dt.setData("text/html", content);
      clipboard.write(dt);
    },
    //剪切
    shear_fn() {
      this.$notify({
        title: "剪切成功",
        type: "success",
        duration: 1000
      });
      this.copy_fn();
      this.delete_fn();
    },
    //上下移动
    moveDom(msg) {
      this.$notify({
        title: "移动成功",
        type: "success",
        duration: 1000
      });
      let one_node = $(choose_node);
      if (msg) {
        one_node.next().insertBefore(one_node);
      } else {
        one_node.prev().insertAfter(one_node);
      }
    },
    //颜色鼠标离开事件
    colorOut(color, nodePool) {
      try {
        nodePool.map(obj => {
          obj.node.style[obj.attr] = color;
        });
        clearInterval(this.clear_time);
        this.clear_time = null;
      } catch (error) {
        console.log(error);
      }
    },
    //颜色鼠标移上事件
    colorOver(color, nodePool) {
      try {
        let i = 0;
        let c0 = hexToRgba(rgb2hex(color), 0);
        clearInterval(this.clear_time);
        this.clear_time = null;
        this.clear_time = setInterval(() => {
          i++;
          if (i % 2 == 0) {
            nodePool.map(obj => {
              obj.node.style[obj.attr] = c0;
            });
          } else {
            nodePool.map(obj => {
              obj.node.style[obj.attr] = color;
            });
          }
        }, 300);
      } catch (error) {
        console.log(error);
      }
    },
    //删除 模块 事件
    delete_fn() {
      this.$notify({
        title: "删除成功",
        type: "success",
        duration: 1000
      });
      $(choose_node).remove();
    },
    //清除 模块 样式
    clear_fn() {
      this.$notify({
        title: "清除样式成功",
        type: "success",
        duration: 1000
      });
      $(choose_node)
        .find("*")
        .each(function(i, e) {
          $(e).attr("style", "");
        });
    },
    //前空行
    insertparagraphtrue_fn() {
      editor.execCommand("insertparagraph", true);
      $(choose_node).removeClass("active");
      $("#poput").hide();
    },
    //后空行
    insertparagraph_fn() {
      editor.execCommand("insertparagraph", false);
      $(choose_node).removeClass("active");
      $("#poput").hide();
    },
    //设置边框
    setBorder() {
      let idx = 0,
        pool = {};
      $(choose_node)
        .find("*")
        .each(function(n, node) {
          if (node && node.nodeType == 1) {
            if (
              node.style["borderTop"] ||
              node.style["borderLeft"] ||
              node.style["borderRight"] ||
              node.style["borderBottom"]
            ) {
              let info = { top: {}, left: {}, right: {}, bottom: {} };
              // seatJudge = true;
              // info.seat[1] = true;
              info.top.color = node.style["borderTopColor"];
              info.left.color = node.style["borderLeftColor"];
              info.right.color = node.style["borderRightColor"];
              info.bottom.color = node.style["borderBottomColor"];
              info.top.style = node.style["borderTopStyle"];
              info.left.style = node.style["borderLeftStyle"];
              info.right.style = node.style["borderRightStyle"];
              info.bottom.style = node.style["borderBottomStyle"];
              info.top.width = parseInt(node.style["borderTopWidth"]) || 0;
              info.left.width = parseInt(node.style["borderLeftWidth"]) || 0;
              info.right.width = parseInt(node.style["borderRightWidth"]) || 0;
              info.bottom.width =
                parseInt(node.style["borderBottomWidth"]) || 0;
              info.top.padding = parseInt(node.style["paddingTop"]) || 0;
              info.left.padding = parseInt(node.style["paddingLeft"]) || 0;
              info.right.padding = parseInt(node.style["paddingRight"]) || 0;
              info.bottom.padding = parseInt(node.style["paddingBottom"]) || 0;
              info.TopLeft = parseInt(node.style["borderTopLeftRadius"]) || 0;
              info.TopRight = parseInt(node.style["borderTopRightRadius"]) || 0;
              info.BottomLeft =
                parseInt(node.style["borderBottomLeftRadius"]) || 0;
              info.BottomRight =
                parseInt(node.style["borderBottomRightRadius"]) || 0;
              // info.node = node;
              node.setAttribute("data-border", `item${idx}`);
              pool[`item${idx}`] = info;
              idx++;
            }
          }
        });
      this.node_border = $("<div></div>")
        .html($(choose_node).clone())
        .html();
      this.items_border = pool;
      this.show_set_border = true;
    },
    //色盘打开
    sctool_color_open(color, value, key) {
      this.nodePool = value;
      this.colorVal = color;
      this.colorIdx = key;
      $("#poputColor").show();
    },
    //更换颜色
    upColorFn(newColor) {
      this.$set(this.colorPool[this.colorIdx], "color", newColor);
      this.colorVal = newColor;
      this.nodePool.map(obj => {
        obj.node.style[obj.attr] = newColor;
      });
    },
    msg_close_set_border_fn(data) {
      if (data) {
        $(choose_node).html(data);
      }
      this.show_set_border = false;
    }
  },
  components: {
    comColor,
    comSetBorder
  },
  created() {
    //非色盘外点击 => 关闭色盘
    document.addEventListener("click", e => {
      if (
        $("#poputColor")[0] != e.target &&
        !$.contains($("#poputColor")[0], e.target) &&
        !$(e.target).data("color")
      ) {
        $("#poputColor").hide();
      }

      if (
        $("#poput")[0] != e.target &&
        !$.contains($("#poput")[0], e.target) &&
        !$(e.target).hasClass("active")
      ) {
        $(choose_node).removeClass("active");
        $("#poput").hide();
      }
    });
  }
};
</script>

<style lang="scss">
.box-poput {
  position: relative;
  z-index: 1000;
}
.sctool-type {
  .el-slider__button {
    width: 10px;
    height: 10px;
    border: 2px solid #fff;
  }

  .el-slider__bar {
    background-color: #fff;
  }
  .el-slider__input {
    width: 50px;
  }

  .el-input--small .el-input__inner {
    height: 20px;
    line-height: 20px;
  }
  .el-input-number--small {
    line-height: 20px;
  }

  .el-input-number--small .el-input__inner {
    padding: 3px 15px 3px 0;
  }

  .sctool-type-l1 .el-input::before {
    content: "%";
    position: absolute;
    right: 3px;
    color: #6d6767;
    top: 0;
    bottom: 0;
  }

  .el-input-number__decrease:hover:not(.is-disabled)
    ~ .el-input
    .el-input__inner:not(.is-disabled),
  .el-input-number__increase:hover:not(.is-disabled)
    ~ .el-input
    .el-input__inner:not(.is-disabled) {
    border-color: #dcdfe6;
    padding-right: 15px;
  }

  .el-input-number__decrease,
  .el-input-number__increase {
    display: none;
  }

  .el-slider__runway {
    margin: 12px 0;
    width: 80%;
    background-color: rgba(255, 255, 255, 0.4);
  }
}
.sctool-color {
  .el-slider__runway {
    margin: 0;
  }
  .el-slider__bar {
    display: none;
  }
  .el-slider__runway {
    height: 10px;
    background: -webkit-linear-gradient(left, rgba(255, 255, 255, 0), #f00);
  }
  .el-slider__button-wrapper {
    top: -13px;
  }
  .el-slider__button {
    width: 13px;
    height: 13px;
    border: none;
    background-color: #fff;
    box-shadow: 0 0px 3px #6d6767;
  }
  .el-input__inner {
    padding: 0;
    display: block;
    height: 18px;
    border: none;
    line-height: 18px;
  }
}
</style>


<style lang="scss" scoped>
.sctool {
  cursor: move;
  display: none;
  z-index: 1000;
  box-shadow: 0 0 3px #475255;
  position: fixed;
  right: 200px;
  top: 100px;
  width: 470px;
  border-radius: 5px;
  background-color: #3b6700;
  box-shadow: rgba(0, 0, 0, 0.3);
  font-size: 13px;
  color: #fff;
  padding: 6px 0 6px 0;
  box-sizing: border-box;

  .com-color {
    display: none;
  }
}
.sctool-round {
  width: 100%;
  overflow: hidden;
  margin-top: 3px;
  pointer-events: none;
  margin-bottom: 1px;
  padding-left: 14px;
  box-sizing: border-box;
}
.sctool-round div {
  pointer-events: initial;
  position: relative;
  line-height: 21px;
  font-size: 18px;
  text-align: center;
  box-sizing: border-box;
  cursor: pointer;
  width: 26px;
  height: 26px;
  border-radius: 50%;
  float: left;
  margin-right: 6px;
  margin-bottom: 4px;
  margin-top: 1px;
  font-weight: 200;
  overflow: hidden;
}
.sctool-round div:hover {
  box-shadow: 0 0 5px #eee inset;
}
.sctool-tool {
  padding-left: 14px;
  box-sizing: border-box;
  pointer-events: none;
  display: flex;
  flex-wrap: wrap;
}
.sctool-tool li {
  float: left;
  pointer-events: initial;
  letter-spacing: 2px;
  text-align: center;
  cursor: pointer;
  line-height: 32px;
  position: relative;
}
.sctool-tool li i {
  position: absolute;
  font-size: 12px;
  top: 10px;
  right: -10px;
}
.sctool-tool li:hover {
  color: $color;
}
.sctool-li0 {
  margin: 10px 13px 0;
  width: 1px;
  height: 12px;
  background-color: rgba(136, 145, 157, 0.4);
}
.sctool-li12 {
  letter-spacing: 1px;
  font-size: 20px;
  margin-top: 1px;
  font-weight: bold;
  margin-left: 0;
}
.sctool-type {
  padding-left: 14px;
  padding-right: 14px;
  box-sizing: border-box;
  padding-bottom: 0;
  display: none;
  width: 470px;
  margin-top: 6px;
  font-size: 13px;
  color: #fff;
  box-sizing: border-box;
  border-top: 1px solid #376000;
  padding-top: 7px;
}
.sctool-type-l1 {
  color: #baff61;
  // font-weight: 100;
  line-height: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.sctool-type-l1 p {
  float: left;
}
.sctool-type-l1-p1 {
  width: 44px;
  text-align: center;
}
.sctool-type-l1-p2 {
  width: 50px;
  text-align: center;
}
.sctool-type-l1-p3 {
  width: 240px;
  height: 6px;
  background-color: #bfbfbf;
  margin-top: 7px;
  position: relative;
}
.sctool-type-l1-p3 i {
  position: absolute;
  width: 200px;
  height: 6px;
  background-color: #fff;
  left: 0;
  top: 0;
}
.sctool-type-l1-p3 span {
  position: absolute;
  width: 6px;
  height: 14px;
  background-color: #fff;
  top: -4px;
  left: 200px;
  cursor: pointer;
}
.sctool-type-l1-p4 {
  width: 50px;
  text-align: center;
  margin-left: 6px;
}
.sctool-type-l1-p5 {
  width: 48px;
  height: 18px;
  margin-left: 8px;
  position: relative;
  margin-top: 1px;
}
.sctool-type-l1-p5 input {
  line-height: 18px;
  box-sizing: border-box;
  border: 0;
  width: 48px;
  height: 18px;
  border-radius: 3px;
  padding: 0 14px 0 4px;
  color: rgba(95, 103, 113, 0.9);
}
.sctool-type-l1-p5 span {
  position: absolute;
  right: 3px;
  top: 0;
  color: #5f7b9e;
  line-height: 20px;
}
.sctool-type-l1-p5 sup {
  box-sizing: border-box;
  position: absolute;
  top: 4px;
  right: 5px;
  width: 5px;
  height: 5px;
  border: 1px solid rgba(95, 103, 113, 0.9);
  border-radius: 50%;
}
.sctool-type-l2 {
  height: 20px;
  color: #fff;
  font-size: 12px;
  // font-weight: 100;
  line-height: 20px;
}
.sctool-type-l2 p {
  float: left;
}
.sctool-type-l2-p1 {
  width: 46px;
  text-align: center;
}
.sctool-type-l2-p2 {
  width: 50px;
  text-align: center;
}
.sctool-type-l2-p2 input {
  float: left;
  margin-left: 18px;
  margin-top: 3px;
  width: 15px;
  height: 15px;
  cursor: pointer;
  background-color: #fff;
}
.sctool-type-l2-p3 {
  margin-right: 3px;
}
.sctool-type-l2-p4 {
  width: 48px;
  height: 18px;
  margin-right: 15px;
  position: relative;
  margin-top: 1px;
  line-height: 16px;
}
.sctool-type-l2-p4 input {
  color: rgba(95, 103, 113, 0.9);
  padding: 0 14px 0 4px;
  box-sizing: border-box;
  border-radius: 3px;
  width: 48px;
  height: 18px;
}
.sctool-type-l2-p4 span {
  position: absolute;
  right: 4px;
  top: 0;
  color: #5f7b9e;
  line-height: 20px;
}
.sctool2-ul {
  position: absolute;
  left: 475px;
  top: 0;
  color: red;
}
.sctool2-l1 {
  font-size: 12px;
  transition: width 0.2s;
  -ms-transition: width 0.2s;
  -moz-transition: width 0.2s;
  -webkit-transition: width 0.2s;
  -o-transition: width 0.5s;
  cursor: pointer;
  height: 28px;
  margin-bottom: 5px;
  width: 28px;
  display: none;
  background-color: #fff;
  overflow: hidden;
  text-align: left;
  line-height: 28px;
  letter-spacing: 4px;
  color: #fff;
  padding: 0 0 0 8px;
  box-sizing: border-box;
  border-radius: 14px;
}
.sctool2-l1:hover {
  width: 60px;
  color: $color !important;
}
.sctool2-l1:hover .sctool2-d1 {
  color: $color !important;
}
.sctool2-l1:hover .sctool2-d1-span1 {
  color: $color !important;
}
.sctool2-l1:hover .disinput {
  color: $color !important;
}
.send-tips {
  position: fixed;
  min-width: 520px;
  top: 0;
  right: 0;
  left: 0;
  z-index: 201;
  background-color: rgba(39, 45, 47, 0.95);
  display: none;
}
.send-tips-main {
  position: relative;
  padding: 0 30px;
  line-height: 40px;
}
.send-tips-text {
  text-align: center;
  font-size: 13px;
  letter-spacing: 2px;
  color: #ff9600;
  color: #ffa800;
  color: #ff9600;
}
.send-tips-text i {
  margin-right: 10px;
}
.send-tips-close {
  position: absolute;
  right: 50px;
  font-size: 16px;
  color: rgba(255, 150, 0, 0.8);
  cursor: pointer;
}
.send-tips-close:hover {
  color: #ff9600;
}
.sctool-phase i {
  position: absolute;
  top: -14px;
  left: 126px;
  color: rgba(71, 82, 85, 0.9);
  font-size: 20px !important;
}
.sctool-phase {
  display: none;
  position: absolute;
  bottom: -118px;
  font-size: 13px;
  color: #535353;
  left: 14px;
}
.sctool-phase ul {
  padding: 10px 0;
  height: 110px;
  box-sizing: border-box;
  box-shadow: 0 0 3px #475255;
  background-color: #535353;
  width: 268px;
  border-radius: 6px;
}
.sctool-phase ul li {
  position: relative;
  float: left;
  height: 22px;
  margin: 4px 10px;
  width: 114px;
}
.sctool-phase ul li p {
  float: left;
  line-height: 22px;
  width: 44px;
  text-align: center;
  letter-spacing: 1px;
  margin-right: 4px;
}
.sctool-phase ul li input {
  float: left;
  height: 22px;
  width: 66px;
  box-sizing: border-box;
  border-radius: 4px;
  padding: 0 16px 0 8px;
  color: #baff61;
}
.sctool-phase ul li span {
  position: absolute;
  right: 3px;
  color: #baff61;
  line-height: 22px;
  font-size: 12px;
}

.sctool-slider {
  width: 85%;
}
</style>



// WEBPACK FOOTER //
// src/components/com-poput.vue